import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { Page401 } from '@/components/Status/401';
import { Page403 } from '@/components/Status/403';
import { Page404 } from '@/components/Status/404';
import AppLayout from '@/layout/AppLayout';
import { publicPlazaPaths } from '@/pages/home/utils/publicPlazaPaths';
import Login from '@/pages/login-page';
import { RedirectComponent } from '@/pages/redirect';
import { ShareLargeScreen } from '@/pages/share/share-large-screen';
import { ShareSystemLargeScreen } from '@/pages/share/share-system-large-screen';
import VncLayout from '@/pages/vnc';
import { lazyNamedImport } from '@/utils/lazyNamedImport';

import { LOGIN_PATH } from '../paths';
import { clusterRouters } from './cluster';
import { dataCenterRouters } from './data-center';
import { orderRouters } from './order';
import { personalRouters } from './personal';
import { systemRouters } from './system';
import { tenantRouters } from './tenant';

export { LOGIN_PATH } from '../paths';

const HomeProductAll = lazyNamedImport(() => import('@/pages/home/product'), 'default');
const HomeCouponCenter = lazyNamedImport(() => import('@/pages/home/coupon-center'), 'default');
const Home = lazy(() => import('@/pages/home'));
const About = lazy(() => import('@/pages/home/about'));
const ModelRepo = lazyNamedImport(() => import('@/pages/home/model-repo'), 'default');
const ModelRepoDetail = lazy(() => import('@/pages/home/model-repo/detail'));
const AppCenter = lazyNamedImport(() => import('@/pages/home/app-center'), 'default');
const AppCenterDetail = lazy(() => import('@/pages/home/app-center/detail'));
const IntelligenceCenter = lazyNamedImport(() => import('@/pages/home/intelligence-center'), 'default');
const SkillCenter = lazyNamedImport(() => import('@/pages/home/skill-center'), 'default');
const SkillCenterDetail = lazy(() => import('@/pages/home/skill-center/detail'));
const SelMode = lazy(() => import('@/pages/login-page/selMode'));
export const routerConfig = [
  {
    path: '/redirect',
    element: <RedirectComponent />,
  },
  {
    path: '/share-screen/dc/:cluster',
    element: <ShareLargeScreen />,
  },
  {
    path: '/show',
    element: <ShareSystemLargeScreen />,
  },
  dataCenterRouters,
  clusterRouters,
  tenantRouters,
  systemRouters,
  orderRouters,
  personalRouters,
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: '/changeMode',
        element: <SelMode />,
      },
    ],
  },
  {
    path: '/vnc',
    element: <VncLayout />,
  },
  {
    index: true,
    element: <Navigate to="/home" />,
  },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: '/home',
        element: <Home />,
      },
      {
        path: '/product/all-skus',
        element: <HomeProductAll />,
      },
      {
        path: '/coupon-center',
        element: <HomeCouponCenter />,
      },
      {
        path: publicPlazaPaths.modelRepo,
        element: <ModelRepo />,
      },
      {
        // /public 标识门户资源广场；dc 段供 PREFIX.oauths_dc / getClusterPrefix 解析
        path: publicPlazaPaths.modelRepoDetailRoute,
        element: <ModelRepoDetail />,
      },
      {
        path: publicPlazaPaths.appCenter,
        element: <AppCenter />,
      },
      {
        // 复用应用版本详情：需 artifactId（应用大类）+ versionId
        path: publicPlazaPaths.appCenterDetailRoute,
        element: <AppCenterDetail />,
      },
      {
        path: '/intelligence-center',
        element: <IntelligenceCenter />,
      },
      {
        path: publicPlazaPaths.skillCenter,
        element: <SkillCenter />,
      },
      {
        path: publicPlazaPaths.skillCenterDetailRoute,
        element: <SkillCenterDetail />,
      },
      {
        path: '/about',
        element: <About />,
      },
    ],
  },
  {
    path: LOGIN_PATH,
    element: <Login />,
  },
  {
    path: '/401',
    element: <Page401 />,
    accessByMobile: true,
  },
  {
    path: '/403',
    element: <Page403 />,
    accessByMobile: true,
  },
  {
    path: '/*',
    element: <Page404 />,
    accessByMobile: true,
  },
];
